var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"flex items-center justify-center rounded-full",class:_vm.data.staticClass,style:({ height: ((_vm.props.size) + "px"), width: ((_vm.props.size) + "px") })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }